<script>
    import StepsProgressBar from '../common/sidebar/StepsProgressBar.svelte'
    import AppComponent from '../common/AppComponent.svelte'
    import UsersPage from "./UsersPage.svelte"
    import {usersPageState} from "./usersState";
</script>

<StepsProgressBar currentPage={3}/>
<AppComponent previousPage="#/organizations" nextPage="#/summary" nextPageEnabled={$usersPageState}>
    <UsersPage/>
</AppComponent>
